
import * as AuthActions from './actions';

//  -- Lib ----------------------------
import { authHelper } from 'utils/lib/authHelper';

//  -- Thunks -------------------------
import { handleGetClass } from 'store/classes/thunks';
import { handleGetDistrictsWithCount, handleGetOrganization } from 'store/organizations/thunks';
import {  handlefetchUserProfileConfig , handleGetUserByUsername } from 'store/users/thunks';
import { handleListUserByClassForTeacher, handleListUserClasses } from 'store/userClasses/thunks';
import { handleInvokeAlert } from "store/alert/thunks"
import { filter, find, get, isEmpty } from "lodash"
import { logToSentry } from "utils/networkErrorUtils";
import { checkWorksheetUser } from "utils/config/reference"
import { clearScoket } from "socket"
import  moment  from 'moment';
import { isValidDateTime } from "utils/methods/validateData";
import { signOut as firebaseSignOut, getAuth } from 'firebase/auth';
import { firebaseApp } from 'firebaseConfig';
import { signOut as awsSignOut, getCurrentUser } from "aws-amplify/auth";
import { clearCredentials } from "@aws-amplify/core";
import { handleAwsLogin } from 'utils/lib/auth';
import { sentryMetaData } from 'utils/sentry';
const auth = getAuth(firebaseApp);
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

import { apis } from 'utils/lib/apis';
import { setCognitoSessionFromTokens } from 'utils/lib/setCognitoSessionFromTokens';
import { ensureAmplifyConfigured } from 'utils/config/initApiConfig';

//  -- User Login ---------------------
export const handleLogin = (data) => async (dispatch) => {
    await dispatch(AuthActions.userLogin());

    try {
        const res = authHelper(data);
        const user = await handleAwsLogin(res);
        sessionStorage.removeItem("username");
        await dispatch(AuthActions.userLoginSuccess("Success"));
        if (user && user.isSignedIn) {
            sessionStorage.setItem("username", res.username);
            return {...user, isSignedIn: true ,username: res.username };
        }
        // const attributes = await fetchUserAttributes()
        return null;
    } catch (error) {
        if (error && error.message == "User is disabled.") {
            dispatch(handleInvokeAlert("Your account is now inactive.", "Please, contact our customer support for answers."))
        }
        if (error && error.code != "NotAuthorizedException") {
            logToSentry({
                message: 'Error logging in',
                error,
                type: 'message',
                module: 'AUTH',
                operation: 'LOGIN',
                tags: { errorCode: error.code }
            });
        }
        await dispatch(AuthActions.userLoginFail(error));
        return false;
    }
};

export const handleLoginWithToken = (ssoToken) => async (dispatch) => {
    try {
        const existingUser = await getCurrentUser().catch(() => null);
        if (existingUser) {
            const username = sessionStorage.getItem('username') || existingUser.username;
            if(username) {
                return { isSignedIn: true, username };
            }
        }
    } catch (_) {}
    await dispatch(AuthActions.userLogin());
    try {
        if (!ssoToken || typeof ssoToken !== 'string' || !ssoToken.trim()) {
            await dispatch(AuthActions.userLoginFail(new Error('Invalid token')));
            return null;
        }
        const response = await apis.post('keystore', '/sso-login-exchange', {
            body: { ssoToken: ssoToken.trim() }
        });
        if (!response?.success || !response?.data) {
            await dispatch(AuthActions.userLoginFail(new Error(response?.message || 'Invalid or expired token')));
            return null;
        }
        const { idToken, accessToken, refreshToken, username } = response.data;
        if (!idToken || !accessToken || !username) {
            await dispatch(AuthActions.userLoginFail(new Error('Invalid session response')));
            return null;
        }
        await ensureAmplifyConfigured();
        await clearCredentials();
        const result = setCognitoSessionFromTokens({ idToken, accessToken, refreshToken, username });
        if (!result.ok) {
            const message = result.reason === 'pool_mismatch'
                ? 'Cognito configuration mismatch. The server and this app are using different environments. Please use the correct login URL or contact support.'
                : 'Failed to set session. Please try again.';
            await dispatch(AuthActions.userLoginFail(new Error(message)));
            return null;
        }
        sessionStorage.removeItem('username');
        sessionStorage.setItem('username', username);
        await dispatch(AuthActions.userLoginSuccess('Success'));
        return { isSignedIn: true, username };
    } catch (error) {
        if (error && error.message == "User is disabled.") {
            dispatch(handleInvokeAlert("Your account is now inactive.", "Please, contact our customer support for answers."))
        }
        if (error && error.code != "NotAuthorizedException") {
            logToSentry({
                message: 'Error logging in with SSO token',
                error,
                type: 'message',
                module: 'AUTH',
                operation: 'LOGIN_WITH_TOKEN',
                tags: { errorCode: error?.code }
            });
        }
        await dispatch(AuthActions.userLoginFail(error));
        return null;
    }
};

//  -- User data fetch ----------------
export const handleRedirect = (data, schoologyUser, firebaseContext) => async (dispatch) => {
    await dispatch(AuthActions.userLogin());
    
    try {
        await dispatch(AuthActions.userLogin());
        const username = sessionStorage.getItem("username") || get(data, 'username');
        const userId = schoologyUser?.id;

        if (!userId&&!username) {
            logToSentry({
                message: 'UserId not found for redirect #1',
                error: new Error(`UserId not found: ${JSON.stringify(data)}`),
                type: 'message',
                module: 'AUTH',
                operation: 'USER_NOT_FOUND',
                tags: { step: '1' }
            });
            dispatch(handleInvokeAlert(`Unable to fetch user information.`));
            return { path: null, currentOrg: null, user: null, message: "Unable to fetch user information due to missing userId." };
        }
        const { user: dbUser, organization: currentOrg, classes, error } = await dispatch(handleGetUserByUsername(userId, username));
        const checkClass = classes?.length === 1 ? classes[0] : false;
        const checkClassArchived = checkClass?.id ? !checkClass?.active ? true : false : false;
        if (!dbUser || error) {
            const rawMessage = typeof error === "string" ? error : error?.message || error?.name || "";
            const signatureMessage = rawMessage.toLowerCase();
            const hasSignatureIssue =
                signatureMessage.includes("signature expired") ||
                signatureMessage.includes("signatureexpired") ||
                signatureMessage.includes("clock drift") ||
                signatureMessage.includes("request time too skewed");
            if (hasSignatureIssue) {
                logToSentry({
                    message: "Signature expired / clock drift while fetching user information",
                    error,
                    module: "AUTH",
                    operation: "DB_USER_NOT_FOUND",
                    tags: { step: "2", signatureExpired: true }
                });
                const alertMessage = "Your device date or time may be incorrect. Please set automatic date and time on your device and try again.";
                dispatch(handleInvokeAlert(alertMessage));
                return { path: null, currentOrg: null, user: null, message: alertMessage };
            }
            logToSentry({
                message: 'dBuser not found #2',
                error: new Error('Database user not found'),
                type: 'message',
                module: 'AUTH',
                operation: 'DB_USER_NOT_FOUND',
                tags: { step: '2' }
            });
            dispatch(handleInvokeAlert(`Unable to fetch user information.`));
            return { path: null, currentOrg: null, user: null, message: "Unable to fetch user information." };
        }

        // const currentOrg = await dispatch(handleGetOrganization(dbUser.orgId));
        if(currentOrg?.id && currentOrg?.parent?.show_archive){
            dispatch(handleInvokeAlert(`Your account is no longer active. Please, contact your organization's${currentOrg?.parent?.displayName ? `(${currentOrg?.parent?.displayName})` : ''} administrator.`));
            return { path: null, currentOrg: null, user: null, message: `Your account is no longer active. Please, contact your organization's${currentOrg?.parent?.displayName ? ` (${currentOrg?.parent?.displayName})` : ''} administrator.` };
        }
        /* TODO temprory disable user account end date checking */
        // if ((dbUser.endDate && moment(dbUser.endDate, "YYYY-MM-DD").isBefore(moment(), "day")) || !dbUser.active) {
        //     dispatch(handleInvokeAlert(`Your account is no longer active. Please, contact your organization's administrator.`));
        //     return { path: null, currentOrg: null, user: null, message: `Your account is no longer active. Please, contact your organization's administrator.` };
        // }
               /* TODO temprory disable user account  */
        // if(has(currentOrg,"permissions.userActive")&&!currentOrg.permissions.userActive){
        //     dispatch(handleInvokeAlert("Your organization is not active. Please, contact your organization's administrator."));
        //     return { path: null, currentOrg: null, user: null, message: "Your organization is not active yet." };
        // }
        if (!dbUser.active || checkClassArchived) {
            dispatch(handleInvokeAlert(`Your account is no longer active. Please, contact your organization's administrator.`));
            return { path: null, currentOrg: null, user: null, message: `Your account is no longer active. Please, contact your organization's administrator.` };
        }
        sentryMetaData(dbUser,currentOrg)
        dispatch(handlefetchUserProfileConfig(dbUser.id))
        if (currentOrg && currentOrg.parent) {
            let parentOrg = currentOrg.parent;
            const startDate = parentOrg.startDate
            const endDate = parentOrg.endDate
            if (startDate && isValidDateTime(startDate) && moment(startDate, "YYYY-MM-DD").isAfter(moment(), "day")) {
                dispatch(handleInvokeAlert("Your organization is not active yet. Please, contact your organization's administrator."));
                return { path: null, currentOrg: null, user: null, message: "Your organization is not active yet." };
            } else if (endDate && isValidDateTime(endDate) && moment(endDate, "YYYY-MM-DD").isBefore(moment(), "day")) {
                dispatch(handleInvokeAlert("Your organization is no longer active. Please, contact your organization's administrator."));
                return { path: null, currentOrg: null, user: null, message: "Your organization is no longer active." };
            } else if (!parentOrg?.active) {
                dispatch(handleInvokeAlert("Your organization is no longer active. Please, contact your organization's administrator."));
                return { path: null, currentOrg: null, user: null, message: "Your organization is no longer active." };
            }
        }

        let roleInfo = {}; 
       
        const roleRedirects = {
            'owe_admin': '/dashboard',
            'admin': '/district',
            'teacher': '/teacher/home',
            'student': '/student/home',
            'parent': '/parents-student-home',
            'placement_admin':'/placement_exam_list'
        };

        const roleWorksheetRedirects = {
            'owe_admin': '/worksheet',
            'admin': '/district',
            'teacher': '/teacher/home',
            'student': '/student/home',
            'parent': '/parents-student-home',
            'placement_admin':'/placement_exam_list'
        };

       

        if (checkWorksheetUser(dbUser?.id)) {
            roleInfo = roleWorksheetRedirects;
        } else {
            roleInfo = roleRedirects;
        }
        if (firebaseContext && firebaseContext.signInWithCustomTokenApi) {
            if (userId || (dbUser && dbUser.id)) {
                const user_id = userId ? userId : dbUser ? dbUser.id : null
                firebaseContext.signInWithCustomTokenApi(user_id)
            }
        }
        return { path: roleInfo[dbUser.role] || '/', currentOrg, user: dbUser, classes: classes, message: null };

    } catch (error) {
        const message = error?.message || error?.name || '';
        const isSignatureExpired = message.includes('Signature expired') || message.includes('Clock drift') || message === 'SignatureExpired';
        if (isSignatureExpired) {
            logToSentry({
                message: 'Signature expired / clock drift during redirect',
                error,
                module: 'AUTH',
                operation: 'REDIRECT',
                tags: { signatureExpired: true }
            });
            dispatch(handleInvokeAlert(`Your device date or time may be incorrect. Please set your device to automatic date and time and try again.`));
            return { path: null, currentOrg: null, user: null, message: "Your device date or time may be incorrect. Please set your device to automatic date and time and try again." };
        }
        logToSentry({
            message: 'Error redirecting',
            error,
            module: 'AUTH',
            operation: 'REDIRECT'
        });
        await dispatch(AuthActions.userLoginFail(error));
        return { path: null, currentOrg: null, user: null, message: "An error occurred during the redirection process." };
    }
};


//  -- User data fetch ----------------
export const handleFetchUserData = (user) => async (dispatch) => {
    if (isEmpty(user)) return;
    await dispatch(AuthActions.userLogin());

    try {
        if (user.role === 'owe_admin') {
            const orgs = await dispatch(handleGetDistrictsWithCount())
            if (Array.isArray(orgs) && orgs.length > 0) {
                let orgId = get(orgs[0], "id")
                const lastActiveOrgAdmin = localStorage.getItem("lastActiveOrgAdmin")
                if (lastActiveOrgAdmin) {
                    if (find(orgs, ["id", lastActiveOrgAdmin])) {
                        orgId = lastActiveOrgAdmin;
                    }
                }
                await dispatch(handleGetOrganization(orgId))
            }
        }
        if (user.role === 'admin') {
            // await dispatch(handleGetOrganization(user.orgId))
        }


        if (user.role === 'teacher') {
            // await dispatch(handleGetOrganization(user.orgId))
             dispatch(handleListUserByClassForTeacher(user.id))
            const classes = await dispatch(handleListUserClasses(user.id));
            const activeClasses = filter(classes,k=>!k.archived)
            const LastActiveclassID = sessionStorage.getItem("LastActiveclassID")
            const hasClass = find(activeClasses, ['id', LastActiveclassID])
            if (hasClass && LastActiveclassID) {
                await dispatch(handleGetClass(hasClass.id));
            } else {
                // if (activeClasses.length > 0) {
                //     await dispatch(handleGetClass(activeClasses[0].id));
                // }
            }

        }
        if (user.role === 'parent') {
            // await dispatch(handleGetOrganization(user.orgId))
            const classes = await dispatch(handleListUserClasses(user.parent_of));
            const activeClasses = filter(classes,k=>!k.archived)
            const LastActiveclassID = sessionStorage.getItem("LastActiveclassID")
            const hasClass = find(activeClasses, ['id', LastActiveclassID])
            if (hasClass && LastActiveclassID) {
                await dispatch(handleGetClass(hasClass.id));
            } else {
                if (activeClasses.length > 0) {
                    await dispatch(handleGetClass(activeClasses[0].id));
                }
            }

        }

        if (user.role === 'student') {
            // await dispatch(handleGetOrganization(user.orgId));
            const classes = await dispatch(handleListUserClasses(user.id));
            const activeClasses = filter(classes,k=>!k.archived)
            const LastActiveclassID = sessionStorage.getItem("LastActiveclassID")
            const hasClass = find(activeClasses, ['id', LastActiveclassID])
            if (hasClass && LastActiveclassID) {
                await dispatch(handleGetClass(hasClass.id));
            } else {
                if (activeClasses.length > 0) {
                    await dispatch(handleGetClass(activeClasses[0].id));
                }
            }
        }


        // TODO: if admin fetch org, classes, users and route to district dashboard
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error fetching user data',
                error,
                module: 'AUTH',
                operation: 'FETCH_USER_DATA'
            });
        }
        await dispatch(AuthActions.userLoginFail(error));
        return false;
    }
};

//  -- User Logout --------------------
export const handleLogout = () => async (dispatch) => {
    await dispatch(AuthActions.userLogout());

    try {
        if(typeof firebaseSignOut=="function"){
            try {
                await firebaseSignOut(auth);
            } catch (error) {
                console.error('Error during Firebase sign-out:', error);
            }
              
        }
        await awsSignOut();
        await dispatch(AuthActions.userLogoutStorageClean())
        await dispatch(AuthActions.userLogoutSuccess('Success'));
        clearScoket()
        return false;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error logging out',
                error,
                module: 'AUTH',
                operation: 'LOGOUT'
            });
        }
        await dispatch(AuthActions.userLogoutFail(error));
    }
};